import React, { useState, useEffect, useRef } from 'react';
import './FAQ.css';

function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);
  const [visibleItems, setVisibleItems] = useState([]);
  const sectionRef = useRef(null);

  const faqs = [
    {
      question: 'How long does it take to build a Shopify store?',
      answer: 'Typically, a custom Shopify store takes 4-6 weeks from initial consultation to launch. This includes design, development, testing, and optimization. Timeline may vary based on project complexity and client feedback cycles.'
    },
    {
      question: 'What\'s included in your Shopify store design service?',
      answer: 'Our service includes custom theme design, mobile optimization, conversion-focused layouts, product page optimization, checkout customization, SEO setup, performance optimization, and post-launch support. We also provide training and documentation.'
    },
    {
      question: 'Do you work with existing Shopify stores?',
      answer: 'Yes! We offer redesign and optimization services for existing Shopify stores. We can improve your current design, enhance user experience, optimize for conversions, and boost performance while maintaining your brand identity.'
    },
    {
      question: 'What is your pricing structure?',
      answer: 'Pricing varies based on project scope, complexity, and specific requirements. Custom store designs start from $3,500, redesigns from $2,500, and optimization projects from $1,200. We provide detailed quotes after understanding your needs.'
    },
    {
      question: 'Will I own my Shopify store after completion?',
      answer: 'Absolutely! You own 100% of your store, design, and code. We provide all source files and documentation. Your Shopify account remains yours, and you have full control over your store.'
    },
    {
      question: 'Do you provide ongoing support after launch?',
      answer: 'Yes, we offer ongoing support packages starting from $300/month. This includes regular updates, performance monitoring, security patches, bug fixes, and priority support. We also offer one-time support for specific needs.'
    },
    {
      question: 'Can you integrate third-party apps and tools?',
      answer: 'Yes, we integrate various Shopify apps, payment gateways, email marketing tools, analytics platforms, and other third-party services. We ensure seamless integration and optimal performance.'
    },
    {
      question: 'What makes your stores conversion-focused?',
      answer: 'We use data-driven design principles, A/B testing, user experience best practices, strategic placement of CTAs, trust elements, social proof, and optimized checkout flows. Every element is designed to guide visitors toward making a purchase.'
    }
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            faqs.forEach((_, index) => {
              setTimeout(() => {
                setVisibleItems((prev) => [...prev, index]);
              }, index * 100);
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="faq-section" ref={sectionRef}>
      <div className="container">
        <div className="section-header fade-in">
          <div className="section-badge">Got Questions?</div>
          <h2 className="section-title">
            Frequently Asked
            <span className="gradient-text"> Questions</span>
          </h2>
          <p className="section-description">
            Everything you need to know about our Shopify store design services.
            Can't find what you're looking for? <a style={{ textDecoration: 'none !important', fontWeight: '600' }} href="#contact">Contact us</a> and we'll be happy to help.
          </p>
        </div>

        <div className="faq-container">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`faq-item ${openIndex === index ? 'open' : ''} ${visibleItems.includes(index) ? 'visible' : ''}`}
            >
              <button
                className="faq-question"
                onClick={() => toggleFAQ(index)}
                aria-expanded={openIndex === index}
              >
                <span className="question-text">{faq.question}</span>
                <span className="faq-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M6 9L12 15L18 9"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </button>
              <div className="faq-answer">
                <div className="answer-content">
                  <p>{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FAQ;
